function addRemoveUnitsInBudget(element, qtdAddPerClick, addOrRemove) {
	var initValue = element.val();
	var initValue_int = parseInt(initValue, 10);
	qtdAddPerClick = parseInt(qtdAddPerClick, 10);
	if (addOrRemove == 'add') {
		element.val(initValue_int + qtdAddPerClick);
	} else {
		element.val(initValue_int - qtdAddPerClick);
	}
	if ($('#page__carrinho').length) {
		setTimeout(function () {
			AtualizaQtde();
		}, 800);
	}
}

function AtualizaQtde() {
	var total = 0;
	$('.inputAdd').each(function(){
			total = total + parseInt($(this).val());
	});
	$('#qtdItens,.numItens').html(total);
}

function validMinimalAmount(element, minimalAmount) {
	var value = element.val();
	var value_int = parseInt(value, 10);
	var minimalAmount = parseInt(minimalAmount, 10);
	if (value_int < minimalAmount) {
		element.val(minimalAmount)
	}
}

function validaCPF(CPF) {
	var erro = 0;
	var Soma;
	var Resto;
	var strCPF = CPF.replace(".", ""); //tira ponto
	strCPF = strCPF.replace(".", ""); //tira o segundo ponto
	strCPF = strCPF.replace("-", ""); //tira hífen
	Soma = 0;
	if (strCPF == "00000000000") erro = 1;
	for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
	Resto = (Soma * 10) % 11;
	if ((Resto == 10) || (Resto == 11)) Resto = 0;
	if (Resto != parseInt(strCPF.substring(9, 10))) erro = 1;
	Soma = 0;
	for (i = 1; i <= 10; i++)
		Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
	Resto = (Soma * 10) % 11;
	if ((Resto == 10) || (Resto == 11)) Resto = 0;
	if (Resto != parseInt(strCPF.substring(10, 11))) erro = 1;
	if (erro == 0) {
		return true;
	} else {
		return false;
	}
}

function validaCNPJ(cnpj) {
	cnpj = cnpj.replace(/[^\d]+/g, '');
	if (cnpj == '') return false;
	if (cnpj.length != 14)
		return false;
	// Elimina CNPJs invalidos conhecidos
	if (cnpj == "00000000000000" ||
		cnpj == "11111111111111" ||
		cnpj == "22222222222222" ||
		cnpj == "33333333333333" ||
		cnpj == "44444444444444" ||
		cnpj == "55555555555555" ||
		cnpj == "66666666666666" ||
		cnpj == "77777777777777" ||
		cnpj == "88888888888888" ||
		cnpj == "99999999999999")
		return false;
	// Valida DVs
	tamanho = cnpj.length - 2
	numeros = cnpj.substring(0, tamanho);
	digitos = cnpj.substring(tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2)
			pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
	if (resultado != digitos.charAt(0))
		return false;
	tamanho = tamanho + 1;
	numeros = cnpj.substring(0, tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2)
			pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
	if (resultado != digitos.charAt(1))
		return false;
	return true;
}


if ($('#page__produto').length) {
	$('#page__produto .infosProduto__tab h3').on('click', function() {
		$(this).toggleClass('is-active');
		$(this).parent().children('.tab__content').toggleClass('is-active');
	});

	$('.addUnidade').on('click', function() {
		addRemoveUnitsInBudget($(this).parent('.c-inputBox').children('.input_numPedido'), $(this).parent('.c-inputBox').children('.input_numPedido').attr('data-multiple'), 'add');
	});
	$('.retirarUnidade').on('click', function() {
		addRemoveUnitsInBudget($(this).parent('.c-inputBox').children('.input_numPedido'), $(this).parent('.c-inputBox').children('.input_numPedido').attr('data-multiple'), 'remove');
		validMinimalAmount($(this).parent('.c-inputBox').children('.input_numPedido'), $(this).parent('.c-inputBox').children('.input_numPedido').attr('data-multiple'));
	});
	$('.input_numPedido').on('focusout', function() {
		validMinimalAmount($(this), $(this).attr('data-multiple'));
	});
}


function getInternetExplorerVersion()
{
	var rv = -1;
	if (navigator.appName == 'Microsoft Internet Explorer')
	{
		var ua = navigator.userAgent;
		var re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");
		if (re.exec(ua) != null)
			rv = parseFloat( RegExp.$1 );
	}
	else if (navigator.appName == 'Netscape')
	{
		var ua = navigator.userAgent;
		var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})");
		if (re.exec(ua) != null)
			rv = parseFloat( RegExp.$1 );
	}
	return rv;
}
if(getInternetExplorerVersion() > 5 && getInternetExplorerVersion() < 13){
	var isIE = true;
}else{
	var isIE = false;
}

if (isIE) {
	//document.write("Você está usando IE! :(");
	//alert('É IE');
}else{
	$("input.foneMask").mask("(99) 9999-9999?9").focusout(function (event) {
		var target, phone, element;
		target = (event.currentTarget) ? event.currentTarget : event.srcElement;
		phone = target.value.replace(/\D/g, '');
		element = $(target);
		element.unmask();
		if(phone.length > 10) {
			element.mask("(99) 99999-999?9");
		} else {
			element.mask("(99) 9999-9999?9");
		}
	});
}

if ($('#page__carrinho').length) {
	$('.order__secondStep .fakeBtn').on('click', function() {
		$('.form__secondStep').toggleClass('is-open');
	});

	$('.addUnidade').on('click', function() {
		addRemoveUnitsInBudget($(this).parent('.c-inputBox').children('.input_numPedido'), $(this).parent('.c-inputBox').children('.input_numPedido').attr('data-multiple'), 'add');
	});
	$('.retirarUnidade').on('click', function() {
		addRemoveUnitsInBudget($(this).parent('.c-inputBox').children('.input_numPedido'), $(this).parent('.c-inputBox').children('.input_numPedido').attr('data-multiple'), 'remove');
		validMinimalAmount($(this).parent('.c-inputBox').children('.input_numPedido'), $(this).parent('.c-inputBox').children('.input_numPedido').attr('data-multiple'));
	});
	$('.input_numPedido').on('focusout', function() {
		validMinimalAmount($(this), $(this).attr('data-multiple'));
	});

	$('.itemShop__deleteItem').on('click', function(e) {
		e.preventDefault();
		var url = $(this).children('a').attr('href');
		if (isIE) {
			window.location = url;
		}else{
			Swal.fire({
				title: 'Tem certeza que deseja remover este produto do carrinho?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#1f2326',
				cancelButtonColor: '#a91f1b',
				confirmButtonText: 'Sim, quero deletar!'
			}).then(function (result) {
				if (result.value) {
					Swal.fire({
						type: 'success',
						title: 'Produto removido do carrinho',
						showConfirmButton: false,
						timer: 2000,
						onClose: function () {
							window.location = url;
						}
					});
				}
			})
		}

		/*if( window.confirm( 'Tem certeza que deseja remover este produto do carrinho de orçamento?' ) )
       {
           $(this).parent('li').remove();
       }*/
	});
}


/*$('.foneMask').focusout(function () {
	var phone, element;
	element = $(this);
	element.unmask();
	phone = element.val().replace(/\D/g, '');
	if (phone.length > 10) {
		element.mask("(99) 99999-999?9");
	} else {
		element.mask("(99) 9999-9999?9");
	}
}).trigger('focusout');

$('.foneMask2').focusout(function () {
	var phone, element;
	element = $(this);
	element.unmask();
	phone = element.val().replace(/\D/g, '');
	if (phone.length > 10) {
		element.mask("(99) 99999-999?9");
	} else {
		element.mask("(99) 9999-9999?9");
	}
}).trigger('focusout');*/

$('.cpf_cnpj_mask').on('keyup', function(e) {
	var query = $(this).val().replace(/[^a-zA-Z 0-9]+/g, '');
	if (query.length == 11) {
		$(".cpf_cnpj_mask").mask("999.999.999-99?99999");
	}
	if (query.length == 14) {
		$(".cpf_cnpj_mask").mask("99.999.999/9999-99");
	}
});

if ($('.formPages').length) {
	$("#formContato").validate({
		submitHandler: function (form) {
			$(form).ajaxSubmit({
				//target: 'status-envio',
				beforeSubmit: function () {
					if (isIE) {
						//window.location = url;
					}else {
						Swal.fire({
							title: 'Enviando mensagem, aguarde...',
							showConfirmButton: false,
							onBeforeOpen: function () {
								Swal.showLoading()
							}
						});
					}
					$('#btnContato').attr('disabled', true);
				},
				success: function (result) {
					result = result.split('|');
					if(parseInt(result[0].charAt(result[0].length-1)) == 1){
						if (isIE) {
							alert('Mensagem enviada com sucesso!');
							setTimeout(function () {
								$('#btnContato').attr('disabled', false);
								$("#formContato .field").val('');
								$("#formContato textarea").val('').html('');
								$("#formContato .field").removeClass('error');
							}, 500)
						}else {
							Swal.fire({
								type: 'success',
								title: 'Mensagem enviada com sucesso!',
								showConfirmButton: false,
								timer: 2000,
								onClose: function () {
									setTimeout(function () {
										$('#btnContato').attr('disabled', false);
										$("#formContato .field").val('');
										$("#formContato textarea").val('').html('');
										$("#formContato .field").removeClass('error');
									}, 500)
								}
							});
						}
					}else{
						if (isIE) {
							alert(result);
							$('#btnContato').attr('disabled', false);
						}else{
							Swal.fire({
								type: 'error',
								title: 'Atenção!',
								text: result,
								showConfirmButton: false,
								timer: 3000,
								onClose: function()  {
									setTimeout(function(){
										$('#btnContato').attr('disabled', false);
									},500)
								}
							});
						}

					}
				}
			});
		}
	});

	$("#formOrcamento").validate({
		submitHandler: function (form) {
			//SUBMIT form
			var cpf_cnpj = $(".cpf_cnpj_mask").val();
			if(validaCNPJ(cpf_cnpj) || validaCPF(cpf_cnpj)) {
				$(form).ajaxSubmit({
					//target: 'status-envio',
					beforeSubmit: function () {
						if (isIE) {
							///
						}else {
							Swal.fire({
								title: 'Enviando orçamento, aguarde...',
								showConfirmButton: false,
								onBeforeOpen: function () {
									Swal.showLoading()
								}
							});
						}
						$('#btnOrcamento').attr('disabled', true);
					},
					success: function (result) {
						result = result.split('|');
						if (parseInt(result[0].charAt(result[0].length - 1)) == 1) {
							window.location = 'obrigado';
						} else {
							if (isIE) {
								alert(result);
								$('#btnOrcamento').attr('disabled', false);
							} else {
								Swal.fire({
									type: 'error',
									title: 'Atenção!',
									text: result,
									showConfirmButton: false,
									timer: 4000,
									onClose: function () {
										setTimeout(function () {
											$('#btnOrcamento').attr('disabled', false);
										}, 500)
									}
								});
							}
						}
					}
				});
			}else{
				if (isIE) {
					alert('CPF ou CNPJ inválido!');
					$(".cpf_cnpj_mask").val('');
					setTimeout(function () {
						$(".cpf_cnpj_mask").focus();
					}, 500)
				}else {
					Swal.fire({
						type: 'error',
						title: 'CPF ou CNPJ inválido!',
						showConfirmButton: false,
						timer: 4000,
						onClose: function () {
							$(".cpf_cnpj_mask").val('');
							setTimeout(function () {
								$(".cpf_cnpj_mask").focus();
							}, 500)
						}
					});
				}
			}
		}
	});
}
$(document).on('click', '.btn-adicionar', function(e) {
	e.preventDefault();
	var produto = $(this).attr('data-produto');
	var input = $(this).parent().parent().children('.c-inputBox').children('input');
	var multiplo = $(this).parent().parent().children('.c-inputBox').children('input').attr('data-multiple');
	var qtd = input.val();
	var totalItens = ($('#qtdItens').html() != '') ? $('#qtdItens').html() : 0;
	if (parseInt(qtd) > 0) {
		$.ajax({
			type: "POST",
			url: "ajax_add_carrinho.php",
			data: 'produto=' + produto + '&qtde=' + qtd,
			success: function(result) {
				console.log(result);
				if (result == 'S') {
					//alert('Produto adicionado com sucesso!');

					if (isIE) {
						alert('Produto adicionado com sucesso!');
					} else {
						Swal.fire({
							type: 'success',
							title: 'Produto adicionado com sucesso!',
							text: 'Clique no carrinho para finalizar seu orçamento.',
							showConfirmButton: false,
							timer: 4000
						});
					}
					$('#qtdItens,.numItens').html(parseInt(qtd) + parseInt(totalItens));
					input.val(multiplo).blur();
					$('#carrinho_call').addClass('s-carrinho_call--withItens');
					$('.carEmpty').addClass('u-dnone');
					$('.carFull').removeClass('u-dnone');
				} else {
					if (isIE) {
						alert(result);
					} else {
						Swal.fire({
							type: 'warning',
							title: 'Atenção!',
							text: result,
							showConfirmButton: false,
							timer: 4000
						});
					}
				}
			}
		});
	} else {
		if (isIE) {
			alert('DETERMINE UMA QUANTIDADE PARA O ITEM!');
		} else {
			Swal.fire({
				type: 'warning',
				title: 'Atenção!',
				text: 'DETERMINE UMA QUANTIDADE PARA O ITEM!',
				showConfirmButton: false,
				timer: 3000
			});
		}
	}
});